import React, { useState, useEffect } from 'react';
import styles from './InspectionModal.module.css';
import CarSection from '../CarSection';
import InspectionSection from '../InspectionSection';
import ContactSection from '../ContactSection';

const InspectionModal = ({ onClose }) => {
  const [openSection, setOpenSection] = useState("car");
  const [selectedStation, setSelectedStation] = useState(null);
  const [selectedCarType, setSelectedCarType] = useState(null);
  const [carCompleted, setCarCompleted] = useState(false);
  const [inspectionCompleted, setInspectionCompleted] = useState(false);
  const [carBrand, setCarBrand] = useState('');
  const [carModel, setCarModel] = useState('');
  const [carPlate, setCarPlate] = useState('');
  const [inspectionComment, setInspectionComment] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedTimeStamp, setSelectedTimeStamp] = useState(null);

  const handleSetSelectedCarType = (carType) => {
    setSelectedCarType(carType);
    // Reset inspection-related states when car type changes
    setSelectedStation(null);
    setInspectionCompleted(false);
    setSelectedDate(null);
    setSelectedTime(null);
    setSelectedTimeStamp(null);
  };
  const [stations, setStations] = useState([]);
  const [loadingStations, setLoadingStations] = useState(true);

  useEffect(() => {
    const fetchStations = async () => {
      try {
        setLoadingStations(true);
      const response = await fetch(`${window.apiBaseUrl || 'https://togto.ru/api/'}getAllSto.php`);
        const data = await response.json();
        setStations(data);
        if (data.length > 0 && !selectedStation) {
          setSelectedStation(data[0]);
        }
      } catch (error) {
        console.error('Error fetching stations:', error);
        setStations([]);
      } finally {
        setLoadingStations(false);
      }
    };
    fetchStations();
  }, [selectedStation, setSelectedStation]);

  useEffect(() => {
    if (!selectedCarType) {
      setSelectedCarType({id: '1', name: 'M1', vehicleType: 'B', descriptionShort: 'не более 8 мест'});
    }
  }, [selectedCarType, setSelectedCarType]);



  return (
    <div className={styles.modal}>
      <button className={styles.close} onClick={onClose} aria-label="Закрыть окно">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M7 5.23072L2.14151 0.371828C1.64742 -0.122299 0.854286 -0.123365 0.365754 0.365208C-0.126185 0.857187 -0.119815 1.64888 0.372374 2.14111L5.23087 7L0.372374 11.8589C-0.119815 12.3511 -0.126185 13.1428 0.365754 13.6348C0.854286 14.1234 1.64742 14.1223 2.14151 13.6282L7 8.76928L11.8585 13.6282C12.3526 14.1223 13.1457 14.1234 13.6342 13.6348C14.1262 13.1428 14.1198 12.3511 13.6276 11.8589L8.76913 7L13.6276 2.14111C14.1198 1.64888 14.1262 0.857187 13.6342 0.365208C13.1457 -0.123365 12.3526 -0.122299 11.8585 0.371828L7 5.23072Z" fill="#5C5C5C" fillOpacity="0.8" />
        </svg>
      </button>

      <div className={styles.header}>
        <h2 className={styles.title}>ЗАПИСЬ НА ТЕХОСМОТР</h2>
        <p className={styles.subtitle}>
          заполните форму, чтобы забронировать удобное время
        </p>
      </div>

      <div className={styles.sections}>
        <CarSection openSection={openSection} setOpenSection={setOpenSection} sectionKey="car" setCarCompleted={setCarCompleted} setCarBrand={setCarBrand} setCarModel={setCarModel} setCarPlate={setCarPlate} setSelectedCarType={handleSetSelectedCarType} />
        <InspectionSection openSection={openSection} setOpenSection={setOpenSection} sectionKey="inspection" carCompleted={carCompleted} setInspectionCompleted={setInspectionCompleted} selectedStation={selectedStation} setSelectedStation={setSelectedStation} setInspectionComment={setInspectionComment} setSelectedDate={setSelectedDate} setSelectedTime={setSelectedTime} setSelectedTimeStamp={setSelectedTimeStamp} selectedCarType={selectedCarType} stations={stations} loadingStations={loadingStations} />
        <ContactSection openSection={openSection} setOpenSection={setOpenSection} sectionKey="contact" inspectionCompleted={inspectionCompleted} selectedStation={selectedStation} selectedCarType={selectedCarType} selectedDate={selectedDate} selectedTime={selectedTime} selectedTimeStamp={selectedTimeStamp} carBrand={carBrand} carModel={carModel} carPlate={carPlate} inspectionComment={inspectionComment} onClose={onClose} />
      </div>
    </div>
  );
};

export default InspectionModal;
